// !!!! - DO NOT MODIFY - !!!!
// THIS FILE IS DEPLOYED AUTOMATICALLY BY MATTv2.
//
//  Deployment info:
//    Updated at:     2026-02-04T11:46:31+00:00
//    Cause:          Manual deployment.
//    Deployment ID:  191213
//    Project:        617
//    Environment:    7626 - master
//    MD5:            1f9fbfb00e90d309115198100029eb74
//    Signature:      eyJpdiI6IkQyYnpQaFhvaWVia2FcL3ZBVU8weFlRPT0iLCJ2YWx1ZSI6IjNKRWZnZmVOTnRVaWhYQUxFZm9tc3VTak1uWjJHWGZ5andTMkZDTVdibjdkY0JvbGtKdjhGU1dPQ0d5SjRUXC90cjVOdUJQS1FkTFVGaTJ0V2llZHNkeUhcL1wvRkFSRjRxNG5SRkoxeExSYlNcL0RZaUMxZmoyWjJIN3dlbjdCaVdIaW1JWG9WdTdOeVdrQ0dMclRjbWFndXZhK1RHaGhNK0E3RVc0Tmk5cGVYMlRQWVVqOUlzYjBTalp3SGZLcjU4MCtjZE4ybVp2bXRnaGZ5XC9HYjRwTVlTZGtZRHZMZHQ3YXI2cE5aXC9jYmxIV3Z5RW5aamR4RWNIWWZ6RDY1RjJvZWtOM1k1NTZnbkhybnd3WFwvV210d0N3NnFVNDNRSHF5Vm40bVFTd0NucmdkZUpqaEVwY1F1SWd3NElMQlRhdTUwN3RFS2N5MTd6TlhvMFl2M1h2QVhPTFEzQUE0d2p3ZHk1MnpmXC9ZK1J0Nzc0NTlkbVZwRk01K1RYV1p4Y0ljRzYwazYzeW92c2RpdXRYUGtYc0ZLcnhldz09IiwibWFjIjoiMzU4NTI2NjJiOGRmMmY5YzU2YzQyYTg4MTkyZmEwMzUwOTFhZmZjNDgyOTU2ZTQwMDU4NzFlOTA3OGNlNmUyNyJ9
const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  optionValueSelectionChange: 'option-value-selection-change',
  variantChange: 'variant-change',
  cartError: 'cart-error',
};
